// extracted by mini-css-extract-plugin
export default {"container":"ImageLoadingTile_container__BvW1l","shimmer":"ImageLoadingTile_shimmer__e57Qm"};